import AccessDeniedSvg from 'assets/access-denied.svg'
import { Text, Box } from 'components'

const AccessDenied = () => (
  <Box height="calc(100vh - 60px)" display="flex" alignItems="center" justifyContent="center">
    <Box>
      <Box display="flex" justifyContent="center">
        <AccessDeniedSvg />
      </Box>
      <Text fontSize={28} fontWeight="medium" color="red" textAlign="center" marginTop={32}>
        access_denied_lbl
      </Text>
      <Text textAlign="center" marginTop={16}>
        access_denied_msg
      </Text>
    </Box>
  </Box>
)

export default AccessDenied
